// import PropTypes from 'prop-types';
import React from 'react';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';
import Modal from 'react-modal';

import BasicButton from '../BasicButton/';
import CreateProjectForm from './CreateProjectForm';
import ImportProjectForm from './ImportProjectForm';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 700,
    maxWidth: 900,
  },
  overlay: {
    zIndex: 1031,
    background: 'rgba(0, 0, 0, 0.6)',
  },
};

const enhance = compose(
  withState('isOpened', 'setOpen', false),
  mapProps(({ setOpen, ...rest }) => ({
    open: () => setOpen(() => true),
    close: () => setOpen(() => false),
    toggle: () => setOpen(s => !s),
    ...rest,
  })),
  withHandlers({
    handleRequestClose: props => () => props.close(),
    handleClick: props => _event => props.open(),
  }),
);

const NewProjectButton = enhance(
  ({
    handleClick,
    handleRequestClose,
    isOpened,
    accountId,
    organizationId,
    create,
  }) => {
    const CreateForm = (create) ? CreateProjectForm : ImportProjectForm;
    return (
      <div style={{ display: 'inline-block' }}>
        <BasicButton className="btn btn-primary ml-2" callback={handleClick}>
          <i className="fa fa-plus" /> {create ? 'Create Project' : 'Import Project'}
        </BasicButton>
        <Modal
          isOpen={isOpened}
          shouldCloseOnOverlayClick
          onRequestClose={handleRequestClose}
          style={customStyles}
        >
          <div>
            <div className="fs-modal-close">
              <div onClick={handleRequestClose} className="modal-close-btn">
                <i className="fa fa fa-times fa-2x" />
              </div>
            </div>
            <CreateForm
              onSuccess={handleRequestClose}
              accountId={accountId}
              organizationId={organizationId}
            />
          </div>
        </Modal>
      </div>
    );
  },
);

export default NewProjectButton;



// WEBPACK FOOTER //
// ./src/components/buttons/NewProjectButtons/NewProjectButton.js